import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "hk-section" }
const _hoisted_2 = { class: "hk-wrap" }
const _hoisted_3 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_main_app_bar = _resolveComponent("main-app-bar")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_connection_row = _resolveComponent("connection-row")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, null, {
    default: _withCtx(() => [
      _createVNode(_component_main_app_bar),
      _createVNode(_component_v_main, {
        class: "hk-app-bg",
        style: _normalizeStyle({ backgroundImage: 'url(' + _ctx.baseImg + ')' })
      }, {
        default: _withCtx(() => [
          _createElementVNode("section", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _cache[1] || (_cache[1] = _createElementVNode("h1", { class: "hk-heading hk-heading--accent mb-10" }, "Rólunk", -1)),
              _createVNode(_component_v_row, {
                align: "center",
                justify: "center",
                class: "mb-4"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    md: "6"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, { class: "hk-card about-image-card" }, {
                        default: _withCtx(() => [
                          _createElementVNode("img", {
                            src: _ctx.machine,
                            class: "about-image",
                            alt: "Hímzőgépünk"
                          }, null, 8, _hoisted_3)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    md: "6"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, { class: "hk-card pa-6 pa-md-8" }, {
                        default: _withCtx(() => _cache[0] || (_cache[0] = [
                          _createElementVNode("h2", { class: "hk-subheading text-md-left mb-4" }, "Üdvözöljük oldalunkon!", -1),
                          _createElementVNode("div", { class: "hk-body" }, [
                            _createElementVNode("p", { class: "mb-4" }, " Örülünk, hogy ellátogatott hozzánk. Vállalkozásunk fő profilja a gépi hímzett termékek készítése – legyen az ruha, táska, párna, sapka vagy törölköző. "),
                            _createElementVNode("p", { class: "mb-4" }, " A hímzett termékek nem csak egyediek, szépek és elegánsak, de divatosak is egyben. Tökéletes választás ünnepre, eseményre, ajándékként vagy személyes használatra. A gépi hímzés előnye más technológiával szemben, hogy tartós: nem fakul ki és nem kopik le. "),
                            _createElementVNode("p", { class: "mb-0" }, " Egyedi elképzelése van? Abban is szívesen segítünk! ")
                          ], -1)
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _cache[2] || (_cache[2] = _createElementVNode("h2", { class: "hk-heading hk-heading--accent mt-12 mb-10" }, "Keressen minket", -1)),
              _createVNode(_component_v_card, { class: "hk-card pa-4 pa-md-8" }, {
                default: _withCtx(() => [
                  _createVNode(_component_connection_row)
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      }, 8, ["style"])
    ]),
    _: 1
  }))
}